module.exports = __webpack_public_path__ + "img/main-title.0619bd86.png";